export const locale = {
    lang: 'pl',
    data: {
        "At checkout": "W kasie",
        "Cash report": "Raport kasowy",
        "Report date": "Data raportu",
        "Proof": "Dowód",
        "Description": "Opis",
        "Delete": "Usuń",
        "Created by": "Utworzył",
        "Created at": "Data dodania",
        "Actions": "Akcje",
        "Income": "Przychod",
        "Outcome": "Rozchód",
        "New income": "Nowy przychód",
        "New outcome": "Nowy rozchód",
        "Cash reports": "Raporty kasowe",
        "Are you sure you want to delete selected item?": "Czy na pewno usunac wybrana pozycję?",
        "Deletion reason": "Powód usuniecia",
        "Deletion reason is required!": "Powód usuniecia jest wymagany!",
        "Deleted by": "Usunął",
        "Deleted at": "Data",
        "Reason": "Powdód",
        "Number": "Numer",
        "Cash": "Gotówka",
        "Date": "Data",
        "Details": "Szczegóły",
        "Print": "Drukuj",
        "Close cash report": "Zamknij raport kasowy",
        "Current cash": "W kasie",
        "Start day cash": "Z przeniesienia",
        "End day cash": "Przeniesiono",
        "Current cash report": "Aktualny raport kasowy",
        "Processing": "Przetwarzanie",
        "Open cash report": "Otwórz raport kasowy",
        "Open day cash": "Z przeniesienia",
        "Opened at": "Data otwarcia",
        "Opened by": "Otworzył",
        "Closed at": "Data zamknięcia",
        "Closed by": "Zamknął",
        "Start day comments": "Komentarz do otwarcia dnia",
        "End day comments": "Komentarz do zamknięcia dnia",
        "Download": "Pobierz",
    }
};
